import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ActionDropDownNew from "./ActionDropDown";
import parse from "html-react-parser";
import {
  checkEmptyString,
  convertFirstLetterOfFullNameToCapital,
  customName,
  formatDateTimeFormat,
} from "../../helpers/commonHelpers";
import LoaderButton from "../Common/LoaderButton";
import NoDataFound from "../Common/NoDataFound";
import Alert from "../Common/Alert";
import ReopenActionModal from "../Action/ReopenActionModal";
import {
  setParentAgendaWithMinutesDetails,
  viewParentMeeting,
} from "../../redux/actions/meetingActions/MeetingAction";
import CommonModal from "../Common/CommonModal";
import {
  cancelLastMeetingAction,
  processReassign,
  setIsSuccess,
  getactionActivitiesDetails,
} from "../../redux/actions/actionAction/ActionAction";
import ReassignModal from "../Action/ReassignModal";
import { Accordion, OverlayTrigger, Popover } from "react-bootstrap";
import { decryptWithAES, encryptWithAES } from "../../helpers/commonHelpers";
import AgendaAccordianHeader from "../Common/AgendaAccordianHeader";
import ParentAgendaAccordianHeader from "../Common/ParentAgendaAccordianHeader";
import PraentMeetingAccordianHeader from "../Common/PraentMeetingAccordianHeader";
import SmallLoaderButton from "../Common/SmallLoaderButton";

const ViewParentActions = (props) => {
  const dispatch = useDispatch();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const accessToken = localStorage.getItem("accessToken");
  const [isReopenMinuteModal, setIsReopenMinuteModal] = useState(false);
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const [isReassignModalOpen, setIsReassignModalOpen] = useState(false);
  const [actionId, setActionId] = useState(null);
  const [minuteDetails, setMinuteDetails] = useState(null);
  const employeeData = useSelector((state) => state.user);
  const meetingData = useSelector((state) => state.meeting);
  const minuteData = useSelector((state) => state.minute);
  const actionData = useSelector((state) => state.action);
  const [meetingDate, setMeetingDate] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    dispatch(setIsSuccess(true));
    if (props.parentMeetingId) {
      dispatch(viewParentMeeting(props.childMeetingId, accessToken));
    } else {
      dispatch(setParentAgendaWithMinutesDetails(null));
    }
    if (actionData?.isSuccess === true) {
      setIsCloseModalOpen(false);
      setIsReassignModalOpen(false);
    }
    return () => {
      setMinuteDetails(null);
      dispatch(setParentAgendaWithMinutesDetails(null));
    };
  }, [props.parentMeetingId, actionData.isSuccess, props.childMeetingId]);

  const handleReassign = async (data) => {
    const result = await dispatch(
      processReassign(
        actionId,
        {
          organizationId: userData.organizationId,
          reAssignedId: data.attendeeId !== "" ? data.attendeeId : undefined,
          reAssignReason: data.reason,
          isNewUser: data.name !== "" && data.email !== "" ? true : false,
          name: data.name,
          email: data.email,
          assignedUsers: data.assignedUsers,
          dueDate: data.date ? data.date : undefined,
          priority: data.priority,
        },
        accessToken
      )
    );
    dispatch(getactionActivitiesDetails(actionId, accessToken));
    if (result?.status) {
      setActionId(null);
      if (props.parentMeetingId && accessToken) {
        dispatch(viewParentMeeting(props.childMeetingId, accessToken));
      }
    }
  };

  const handleReopenActionModal = (status, minute) => {
    minute["modalStatus"] = "REOPEN";
    setMinuteDetails(minute);
    setIsReopenMinuteModal(status);
  };

  const handleApproveActionModal = (status, minute) => {
    minute["modalStatus"] = "APPROVE";
    console.log("minute---", minute);
    setMinuteDetails(minute);
    setIsReopenMinuteModal(status);
  };

  const handleCancelAction = (status, minute) => {
    setMinuteDetails(minute);
    setIsCloseModalOpen(status);
  };

  const submitCancelAction = async () => {
    const payload = {
      assignedUserDetails: minuteDetails?.assignedUserDetails,
    };
    setLoading(true);
    const result = await dispatch(
      cancelLastMeetingAction(
        props.parentMeetingId,
        minuteDetails?._id,
        accessToken,
        payload
      )
    );
    setLoading(false);
    if (result?.status) {
      if (props.parentMeetingId && accessToken) {
        dispatch(viewParentMeeting(props.childMeetingId, accessToken));
      }
      setIsCloseModalOpen(false);
    }
  };

  const handleReassignModal = (actionId, minute, meetingDate) => {
    setActionId(actionId);
    setIsReassignModalOpen(true);
    setMinuteDetails(minute);
    setMeetingDate(meetingDate);
  };

  const isMeetingOrganiser =
    meetingData?.timeLineDatas?.parentMeetingDetails?.createdById?.toString() ===
    employeeData?.userData?._id?.toString()
      ? true
      : false;

  const popoverHoverFocus = (title) => {
    return (
      <Popover id="popover-basic" className="custom-popover">
        <Popover.Body className="popover-body">{title}</Popover.Body>
      </Popover>
    );
  };
  return (
    <>
      {meetingData?.parentAgendaDetails?.length !== 0 ? (
        <form className="mt-4 details-form details-form-right">
          <div className="form-group agenda">
            <label className="mt-3 mb-3 add-agenda">
              <h4 className="mb-0">Last Meeting Action Points Status</h4>
            </label>

            {meetingData?.parentAgendaDetails?.filter(
              (item) => item?.agendas?.length !== 0
            )?.length !== 0 ? (
              <>
                {meetingData?.parentAgendaDetails
                  ?.filter((item) => item?.agendas?.length !== 0)
                  .map((mainData, index) => {
                    return (
                      <>
                        {mainData?.agendas?.length !== 0 ? (
                          <div className="mt-1 agenda-box-border">
                            <Accordion
                              defaultActiveKey="0"
                              className="accordian-padding"
                            >
                              <Accordion.Item
                                eventKey="0"
                                className="agenda-accordion acordionnn last-meeting-action-accordion"
                              >
                                <PraentMeetingAccordianHeader
                                  meeting={mainData?._id}
                                />

                                <Accordion.Body>
                                  {mainData?.agendas?.map((agenda, index) => {
                                    const allActions = (
                                      agenda?.minutesDetail || []
                                    ).filter(
                                      (action) =>
                                        action?.isAction === true &&
                                        // action?.isComplete === false &&
                                        action?.isApproved === false &&
                                        action?.isCancelled === false
                                    );

                                    return (
                                      <>
                                        {agenda?.minutesDetail?.length !== 0 &&
                                        agenda?.minutesDetail?.filter(
                                          (minute) => minute.isAction === true
                                        ).length !== 0 ? (
                                          <Accordion key={index}>
                                            <div className="mt-1 agenda-box-border">
                                              <Accordion.Item
                                                eventKey={index.toString()}
                                                className="agenda-accordion"
                                              >
                                                <ParentAgendaAccordianHeader
                                                  agenda={agenda}
                                                  index={index}
                                                  minutesCount={
                                                    agenda?.minutesDetail
                                                      ?.length
                                                  }
                                                />

                                                {/* <Accordion.Header className="accordion-headerrr">
                                                  {agenda.title?.length > 50 ? (
                                                    <OverlayTrigger
                                                      trigger={[
                                                        "hover",
                                                        "focus",
                                                      ]}
                                                      placement="top"
                                                      overlay={popoverHoverFocus(
                                                        agenda.title
                                                      )}
                                                    >
                                                      <div className="d-flex justify-content-between w-100">
                                                        <div className="d-flex justify-content-between">
                                                          <span className="meeting-title-hover">
                                                            <span className="">
                                                              Agenda {index + 1}
                                                              :&nbsp;
                                                            </span>
                                                            <span className="pre-wrap-text">{`${agenda.title.slice(
                                                              0,
                                                              50
                                                            )}`}</span>
                                                          </span>
                                                        </div>
                                                        <div>
                                                          <span className="agenda-span badge">
                                                            {
                                                              agenda
                                                                ?.minutesDetail
                                                                ?.length
                                                            }
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </OverlayTrigger>
                                                  ) : (
                                                    <div className="d-flex justify-content-between w-100">
                                                      <div className="d-flex justify-content-between">
                                                        <span className="meeting-title-hover">
                                                          <span className="">
                                                            Agenda {index + 1}
                                                            :&nbsp;
                                                          </span>
                                                          <span className="pre-wrap-text">{`${agenda.title.slice(
                                                            0,
                                                            50
                                                          )}`}</span>
                                                        </span>
                                                      </div>
                                                      <div>
                                                        <span className="agenda-span badge">
                                                          {allActions?.length}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  )}
                                                </Accordion.Header> */}
                                                <Accordion.Body>
                                                  <div className="p-3">
                                                    <div className="form-group">
                                                      <div className="row">
                                                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                                          <label className="mt-1 mb-1">
                                                            Agenda Title
                                                          </label>
                                                        </div>
                                                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                                          <p> {agenda.title}</p>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    {checkEmptyString(
                                                      agenda.topic
                                                    ) === null ||
                                                    checkEmptyString(
                                                      agenda.topic
                                                    ) === " " ||
                                                    checkEmptyString(
                                                      agenda.topic
                                                    ) === undefined ? null : (
                                                      <>
                                                        <div className="form-group">
                                                          <div className="row">
                                                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                                              <label className="mt-2 topic">
                                                                Topic to Discuss
                                                              </label>
                                                            </div>
                                                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                                              <div className="text-editor">
                                                                {" "}
                                                                {agenda?.topic
                                                                  ? parse(
                                                                      decryptWithAES(
                                                                        agenda.topic
                                                                      )
                                                                    )
                                                                  : null}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </>
                                                    )}
                                                    <div className=" form-group">
                                                      <div className="row">
                                                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                                          <label className="mt-1 mb-1">
                                                            Timeline
                                                          </label>
                                                        </div>
                                                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                                          <p>
                                                            {" "}
                                                            {
                                                              agenda.timeLine
                                                            }{" "}
                                                            Min
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    {agenda?.minutesDetail?.filter(
                                                      (item) =>
                                                        item.isActive === true
                                                    ).length !== 0 ? (
                                                      <>
                                                        <div></div>
                                                        <div className=" minutes-border"></div>

                                                        {agenda?.minutesDetail?.filter(
                                                          (item) =>
                                                            item.isActive ===
                                                              true &&
                                                            item.isAction ===
                                                              true
                                                        ).length !== 0 &&
                                                          agenda?.minutesDetail
                                                            ?.filter(
                                                              (item) =>
                                                                item.isActive ===
                                                                  true &&
                                                                item.isAction ===
                                                                  true
                                                            )
                                                            .map(
                                                              (
                                                                minute,
                                                                index
                                                              ) => {
                                                                function updateIsMinutesRsvpStatusModal(
                                                                  arg0,
                                                                  arg1
                                                                ) {
                                                                  throw new Error(
                                                                    "Function not implemented."
                                                                  );
                                                                }

                                                                function handleAmendmentRequestModal(
                                                                  _id
                                                                ) {
                                                                  throw new Error(
                                                                    "Function not implemented."
                                                                  );
                                                                }

                                                                return (
                                                                  <>
                                                                    <div className="agenda-minutes d-block">
                                                                      <div className=" form-group">
                                                                        <div className="row">
                                                                          <div className="col-md-4">
                                                                            <label className="">
                                                                              Minutes{" "}
                                                                              {index +
                                                                                1}
                                                                            </label>
                                                                          </div>
                                                                          <div className="col-md-6">
                                                                            {" "}
                                                                            {
                                                                              minute.title
                                                                            }
                                                                          </div>

                                                                          <div className="col-md-2 d-flex justify-content-end">
                                                                            <div className="btn-outerbox">
                                                                              {!props.meetingId &&
                                                                              !props.isHideOptions &&
                                                                              (mainData?._id?.createdById?.toString() ===
                                                                                employeeData?.userData?._id?.toString() ||
                                                                                employeeData
                                                                                  ?.userData
                                                                                  ?.isAdmin ===
                                                                                  true ||
                                                                                meetingData
                                                                                  ?.meetingDetails
                                                                                  ?.canWriteMOM ===
                                                                                  true) &&
                                                                              minute.isCancelled ===
                                                                                false &&
                                                                              minute.isApproved ===
                                                                                false ? (
                                                                                <div className="d-inline-block menu-dropdown custom-dropdown">
                                                                                  <ActionDropDownNew
                                                                                    isCalledFromViewAction={
                                                                                      false
                                                                                    }
                                                                                    minuteId={
                                                                                      minute._id
                                                                                    }
                                                                                    actionDetails={
                                                                                      minute
                                                                                    }
                                                                                    isFollowOnMeeting={
                                                                                      true
                                                                                    }
                                                                                    handleReopenActionModal={() => {
                                                                                      handleReopenActionModal(
                                                                                        true,
                                                                                        minute
                                                                                      );
                                                                                    }}
                                                                                    handleApproveActionModal={() => {
                                                                                      handleApproveActionModal(
                                                                                        true,
                                                                                        minute
                                                                                      );
                                                                                    }}
                                                                                    handleCancelActionModal={() => {
                                                                                      handleCancelAction(
                                                                                        true,
                                                                                        minute
                                                                                      );
                                                                                    }}
                                                                                    handleReassignModal={() => {
                                                                                      handleReassignModal(
                                                                                        minute?._id,
                                                                                        minute,
                                                                                        agenda
                                                                                          ?.meetingDetail
                                                                                          ?.date
                                                                                      );
                                                                                    }}
                                                                                  />
                                                                                </div>
                                                                              ) : null}
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      {checkEmptyString(
                                                                        minute?.description
                                                                      ) ===
                                                                        null ||
                                                                      checkEmptyString(
                                                                        minute?.description
                                                                      ) ===
                                                                        " " ||
                                                                      checkEmptyString(
                                                                        minute?.description
                                                                      ) ===
                                                                        undefined ? null : (
                                                                        <div className=" form-group">
                                                                          <div className="row">
                                                                            <div className="col-md-4">
                                                                              <label className="">
                                                                                Description
                                                                              </label>
                                                                            </div>
                                                                            <div className="col-md-8">
                                                                              <div className="text-editor">
                                                                                {" "}
                                                                                {minute.description
                                                                                  ? parse(
                                                                                      decryptWithAES(
                                                                                        minute.description
                                                                                      )
                                                                                    )
                                                                                  : null}
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      )}

                                                                      <div className="form-group">
                                                                        <div className="row">
                                                                          <div className="col-md-4">
                                                                            <label className="">
                                                                              Status
                                                                            </label>
                                                                          </div>
                                                                          <div className="col-md-8">
                                                                            <p>
                                                                              {minute.isApproved ===
                                                                                true &&
                                                                              minute.isCancelled ===
                                                                                false ? (
                                                                                <span className="badge approved-color bg-opacity-10 ">
                                                                                  Approved
                                                                                </span>
                                                                              ) : minute.isComplete ===
                                                                                  true &&
                                                                                minute.isCancelled ===
                                                                                  false ? (
                                                                                <span className="badge completed-color bg-opacity-10 ">
                                                                                  Completed
                                                                                </span>
                                                                              ) : minute.isReopened ===
                                                                                  true &&
                                                                                minute.isCancelled ===
                                                                                  false ? (
                                                                                <span className="badge reopened-color bg-opacity-10 ">
                                                                                  Reopened
                                                                                </span>
                                                                              ) : minute.isCancelled ===
                                                                                true ? (
                                                                                <span className="badge canceled-color bg-opacity-10 ">
                                                                                  Cancelled
                                                                                </span>
                                                                              ) : (
                                                                                <span className="badge pending-color bg-opacity-10 ">
                                                                                  Pending
                                                                                </span>
                                                                              )}
                                                                            </p>
                                                                          </div>
                                                                        </div>
                                                                      </div>

                                                                      {minute.isAction ? (
                                                                        <>
                                                                          <div className=" form-group">
                                                                            <div className="row">
                                                                              <div className="col-md-4">
                                                                                <label className="mt-1 mb-1">
                                                                                  Due
                                                                                  Date
                                                                                </label>
                                                                              </div>
                                                                              <div className="col-md-8">
                                                                                <p>
                                                                                  {" "}
                                                                                  {
                                                                                    formatDateTimeFormat(
                                                                                      minute?.dueDate
                                                                                    )
                                                                                      .formattedDate
                                                                                  }
                                                                                </p>
                                                                              </div>
                                                                            </div>
                                                                          </div>

                                                                          <div className=" form-group">
                                                                            <div className="row">
                                                                              <div className="col-md-4">
                                                                                <label className="mt-1 mb-1">
                                                                                  Priority
                                                                                </label>
                                                                              </div>
                                                                              <div className="col-md-8">
                                                                                <p>
                                                                                  {" "}
                                                                                  {minute.priority
                                                                                    .charAt(
                                                                                      0
                                                                                    )
                                                                                    .toUpperCase() +
                                                                                    minute.priority
                                                                                      .slice(
                                                                                        1
                                                                                      )
                                                                                      .toLowerCase()}
                                                                                </p>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          {minute?.isAction ? (
                                                                            <div className=" form-group">
                                                                              <div className="row">
                                                                                <div className="col-md-4">
                                                                                  <label className="mt-1 mb-1">
                                                                                    Responsible
                                                                                    Person
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-md-8">
                                                                                  {/* <p>
                                                                                    {minute?.assignedUserDetails?.length > 0 ? (() => {
                                                                                      const users = minute.assignedUserDetails
                                                                                        .map((user) => convertFirstLetterOfFullNameToCapital(user?.name))
                                                                                        .filter(Boolean);

                                                                                      if (users.length === 1) return users[0];
                                                                                      if (users.length === 2) return users.join(" and ");

                                                                                      return `${users.slice(0, -1).join(", ")} and ${users[users.length - 1]}`;
                                                                                    })() : null}
                                                                                  </p> */}
                                                                                  <p>
                                                                                    {minute
                                                                                      ?.assignedUserDetails
                                                                                      ?.length >
                                                                                      0 &&
                                                                                      minute.assignedUserDetails
                                                                                        .map(
                                                                                          (
                                                                                            user
                                                                                          ) =>
                                                                                            convertFirstLetterOfFullNameToCapital(
                                                                                              user?.name
                                                                                            )
                                                                                        )
                                                                                        .filter(
                                                                                          Boolean
                                                                                        )
                                                                                        .map(
                                                                                          (
                                                                                            name,
                                                                                            index
                                                                                          ) => (
                                                                                            <div
                                                                                              key={
                                                                                                index
                                                                                              }
                                                                                            >
                                                                                              {
                                                                                                name
                                                                                              }
                                                                                            </div>
                                                                                          )
                                                                                        )}
                                                                                  </p>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          ) : null}
                                                                        </>
                                                                      ) : null}

                                                                      {/* {minute.reassignDetails ? (
                                                                        <div className=" form-group">
                                                                          <div className="row">
                                                                            <div className="col-md-4">
                                                                              <label className="mt-1 mb-1">
                                                                                Reassigned
                                                                                To
                                                                              </label>
                                                                            </div>
                                                                            <div className="col-md-8 detail ">
                                                                              <p>
                                                                                Rakesh
                                                                                Baral
                                                                              </p>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      ) : null} */}

                                                                      {minute
                                                                        ?.attendees
                                                                        ?.length ==
                                                                      0 ? (
                                                                        <>
                                                                          <div className="form-group mt-4">
                                                                            <div className="row">
                                                                              <div className="col-md-4">
                                                                                <label className="mt-2 topic">
                                                                                  Accepted
                                                                                  By
                                                                                </label>
                                                                              </div>
                                                                              <div
                                                                                className="col-md-8"
                                                                                onClick={() =>
                                                                                  updateIsMinutesRsvpStatusModal(
                                                                                    "Accepted",
                                                                                    minute?.attendees?.filter(
                                                                                      (
                                                                                        attendee
                                                                                      ) =>
                                                                                        attendee.status ===
                                                                                        "ACCEPTED"
                                                                                    )
                                                                                  )
                                                                                }
                                                                              >
                                                                                {minute?.attendees?.filter(
                                                                                  (
                                                                                    attendee
                                                                                  ) =>
                                                                                    attendee.status ===
                                                                                    "ACCEPTED"
                                                                                )
                                                                                  .length !==
                                                                                  0 &&
                                                                                  minute?.attendees
                                                                                    ?.filter(
                                                                                      (
                                                                                        attendee
                                                                                      ) =>
                                                                                        attendee.status ===
                                                                                        "ACCEPTED"
                                                                                    )
                                                                                    .map(
                                                                                      (
                                                                                        attendee
                                                                                      ) => {
                                                                                        return (
                                                                                          <>
                                                                                            <div className="attendees mb-2">
                                                                                              <div className="attendee-list">
                                                                                                {customName(
                                                                                                  attendee.name
                                                                                                )}
                                                                                              </div>
                                                                                              {}

                                                                                              <p className="plus-more-text m-0">
                                                                                                {minute
                                                                                                  .attendees
                                                                                                  .length >
                                                                                                5
                                                                                                  ? `+${
                                                                                                      minute
                                                                                                        .attendees
                                                                                                        .length -
                                                                                                      5
                                                                                                    } More`
                                                                                                  : null}
                                                                                              </p>
                                                                                            </div>
                                                                                          </>
                                                                                        );
                                                                                      }
                                                                                    )}

                                                                                <p>
                                                                                  Accepted
                                                                                  by{" "}
                                                                                  {
                                                                                    minute?.attendees?.filter(
                                                                                      (
                                                                                        attendee
                                                                                      ) =>
                                                                                        attendee.status ===
                                                                                        "ACCEPTED"
                                                                                    )
                                                                                      .length
                                                                                  }

                                                                                  /
                                                                                  {
                                                                                    minute
                                                                                      .attendees
                                                                                      .length
                                                                                  }{" "}
                                                                                  attendants
                                                                                </p>
                                                                              </div>
                                                                            </div>
                                                                          </div>

                                                                          <div className="form-group mt-4">
                                                                            <div className="row">
                                                                              <div className="col-md-4">
                                                                                <label className="mt-2 topic">
                                                                                  Rejected
                                                                                  By
                                                                                </label>
                                                                              </div>
                                                                              <div
                                                                                className="col-md-8"
                                                                                onClick={() =>
                                                                                  updateIsMinutesRsvpStatusModal(
                                                                                    "Rejected",
                                                                                    minute?.attendees?.filter(
                                                                                      (
                                                                                        attendee
                                                                                      ) =>
                                                                                        attendee.status ===
                                                                                        "REJECTED"
                                                                                    )
                                                                                  )
                                                                                }
                                                                              >
                                                                                {minute?.attendees?.filter(
                                                                                  (
                                                                                    attendee
                                                                                  ) =>
                                                                                    attendee.status ===
                                                                                    "REJECTED"
                                                                                )
                                                                                  .length !==
                                                                                  0 &&
                                                                                  minute?.attendees
                                                                                    ?.filter(
                                                                                      (
                                                                                        attendee
                                                                                      ) =>
                                                                                        attendee.status ===
                                                                                        "REJECTED"
                                                                                    )
                                                                                    .map(
                                                                                      (
                                                                                        attendee
                                                                                      ) => {
                                                                                        return (
                                                                                          <>
                                                                                            <div className="attendees mb-2">
                                                                                              <div className="attendee-list">
                                                                                                {customName(
                                                                                                  attendee.name
                                                                                                )}
                                                                                              </div>
                                                                                              {}

                                                                                              <p className="plus-more-text m-0">
                                                                                                {minute
                                                                                                  .attendees
                                                                                                  .length >
                                                                                                5
                                                                                                  ? `+${
                                                                                                      minute
                                                                                                        .attendees
                                                                                                        .length -
                                                                                                      5
                                                                                                    } More`
                                                                                                  : null}
                                                                                              </p>
                                                                                            </div>
                                                                                          </>
                                                                                        );
                                                                                      }
                                                                                    )}

                                                                                <p>
                                                                                  Rejected
                                                                                  by{" "}
                                                                                  {
                                                                                    minute?.attendees?.filter(
                                                                                      (
                                                                                        attendee
                                                                                      ) =>
                                                                                        attendee.status ===
                                                                                        "REJECTED"
                                                                                    )
                                                                                      .length
                                                                                  }

                                                                                  /
                                                                                  {
                                                                                    minute
                                                                                      .attendees
                                                                                      .length
                                                                                  }{" "}
                                                                                  attendants
                                                                                </p>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </>
                                                                      ) : null}
                                                                      {!isMeetingOrganiser &&
                                                                      props.meetingId ? (
                                                                        <div>
                                                                          <></>
                                                                          <div className=" minutes-border"></div>
                                                                        </div>
                                                                      ) : null}

                                                                      {isMeetingOrganiser &&
                                                                      minute
                                                                        ?.amendmentDetails
                                                                        ?.length !==
                                                                        0 ? (
                                                                        <div className="added-by">
                                                                          {minute?.amendmentDetails?.map(
                                                                            (
                                                                              amendment
                                                                            ) => {
                                                                              function handleAmendmentUpdateByButton(
                                                                                arg0,
                                                                                createdById,
                                                                                _id
                                                                              ) {
                                                                                throw new Error(
                                                                                  "Function not implemented."
                                                                                );
                                                                              }

                                                                              return (
                                                                                <>
                                                                                  <div className="add-agenda">
                                                                                    <p className="add-text">
                                                                                      Amendment
                                                                                      Requested
                                                                                      By
                                                                                    </p>
                                                                                    <div className="attendee1 attendee-list">
                                                                                      {customName(
                                                                                        amendment.name
                                                                                      )}
                                                                                    </div>
                                                                                  </div>
                                                                                  <div
                                                                                    className="view"
                                                                                    onClick={() => {
                                                                                      handleAmendmentRequestModal(
                                                                                        minute._id,
                                                                                        amendment.details,
                                                                                        amendment.createdById
                                                                                      );
                                                                                    }}
                                                                                  >
                                                                                    <p>
                                                                                      View
                                                                                      Details
                                                                                    </p>
                                                                                  </div>

                                                                                  <div className="add-agenda">
                                                                                    <div className="pe-2">
                                                                                      {minuteData.loading &&
                                                                                      minuteData.status ===
                                                                                        "REJECTED" ? (
                                                                                        <SmallLoaderButton />
                                                                                      ) : (
                                                                                        <button
                                                                                          className="add-minutes Mom-btn"
                                                                                          type="button"
                                                                                          onClick={() =>
                                                                                            handleAmendmentUpdateByButton(
                                                                                              "ACCEPTED",
                                                                                              amendment.createdById,
                                                                                              minute._id
                                                                                            )
                                                                                          }
                                                                                        >
                                                                                          <p>
                                                                                            Accept
                                                                                          </p>
                                                                                        </button>
                                                                                      )}
                                                                                    </div>

                                                                                    <div>
                                                                                      {minuteData.loading &&
                                                                                      minuteData.status ===
                                                                                        "REJECTED" ? (
                                                                                        <SmallLoaderButton />
                                                                                      ) : (
                                                                                        <button
                                                                                          className=" reset"
                                                                                          type="button"
                                                                                          onClick={() =>
                                                                                            handleAmendmentUpdateByButton(
                                                                                              "REJECTED",
                                                                                              amendment.createdById,
                                                                                              minute._id
                                                                                            )
                                                                                          }
                                                                                        >
                                                                                          <p>
                                                                                            Reject
                                                                                          </p>
                                                                                        </button>
                                                                                      )}
                                                                                    </div>
                                                                                  </div>
                                                                                </>
                                                                              );
                                                                            }
                                                                          )}
                                                                        </div>
                                                                      ) : null}
                                                                    </div>
                                                                    <div className=" minutes-border"></div>
                                                                  </>
                                                                );
                                                              }
                                                            )}
                                                      </>
                                                    ) : null}
                                                  </div>
                                                </Accordion.Body>
                                              </Accordion.Item>
                                            </div>
                                          </Accordion>
                                        ) : (
                                          <div className="no-data-img mt-3">
                                            <Alert
                                              status={"info"}
                                              message={"No data available."}
                                              timeoutSeconds={0}
                                            />

                                            <NoDataFound dataType={"meeting"} />
                                          </div>
                                        )}
                                      </>
                                    );
                                  })}
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>

                            <></>
                          </div>
                        ) : (
                          <div className="no-data-img mt-3">
                            <Alert
                              status={"info"}
                              message={"No data available."}
                              timeoutSeconds={0}
                            />

                            <NoDataFound dataType={"meeting"} />
                          </div>
                        )}
                      </>
                    );
                  })}
              </>
            ) : (
              <div className="no-data-img mt-3">
                <Alert
                  status={"info"}
                  message={"No data available."}
                  timeoutSeconds={0}
                />

                <NoDataFound dataType={"meeting"} />
              </div>
            )}
          </div>
          {/* <ReopenActionModal
            meetingId={minuteDetails?.meetingId}
            minuteDetails={minuteDetails}
            IsReopenMinuteModal={isReopenMinuteModal}
            setIsReopenMinuteModal={setIsReopenMinuteModal}
            accessToken={accessToken}
            parentMeetingId={props.parentMeetingId}
            childMeetingId={props.childMeetingId}
          /> */}

          <ReopenActionModal
            meetingId={minuteDetails?.meetingId}
            minuteDetails={minuteDetails}
            IsReopenMinuteModal={isReopenMinuteModal}
            setIsReopenMinuteModal={setIsReopenMinuteModal}
            accessToken={accessToken}
            parentMeetingId={props.parentMeetingId}
            isCalledFromViewAction={false}
            childMeetingId={props.childMeetingId}
            actionId={props.actionId}
          />

          <CommonModal
            message={"Do you want to cancel the action ?"}
            title={"Cancel Action"}
            setIsModalOpen={setIsCloseModalOpen}
            isModalOpen={isCloseModalOpen}
            handleSubmit={submitCancelAction}
            buttonName={"Cancel"}
            isCalledFromOthers={true}
          />
          <ReassignModal
            setIsReassignModalOpen={setIsReassignModalOpen}
            isModalOpen={isReassignModalOpen}
            handleSubmit={handleReassign}
            actionData={minuteDetails}
            meetingDate={meetingDate}
          />
        </form>
      ) : null}
    </>
  );
};

export default ViewParentActions;
